import { forwardRef } from "react";
import DatePicker from "react-datepicker";
import { addDays } from "date-fns";

import "./InputDate.scss";

interface CustomInputProps {
  value?: string;
  onClick?: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
}

interface InputDateProps {
  label: string;
  value: Date | null;
  invalidMsg?: string;
  onChange: (date: Date | null) => void;
  darkMode: boolean;
}

const InputDate = (props: InputDateProps) => {
  const DateInputField = forwardRef<HTMLSpanElement, CustomInputProps>(
    ({ value, onClick }, ref) => (
      <input type="text" onClick={onClick} value={value} readOnly />
    )
  );
  DateInputField.displayName = "DateInputField";

  return (
    <div className={"input-date-wrapper" + (props.darkMode ? " dark" : "")}>
      <label className="input-label">{props.label}</label>
      <DatePicker
        dateFormat="yyyy-MM-dd"
        selected={props.value}
        onChange={props.onChange}
        minDate={addDays(new Date(), 1)}
        customInput={<DateInputField />}
      />
      {props.invalidMsg && (
        <div className="invalid-msg">{props.invalidMsg}</div>
      )}
    </div>
  );
};

export default InputDate;
